import axios from 'axios';
import * as Sentry from '@sentry/react';
import { getToken, getTokenHeader } from '../../../../../screen/auth/action';
import { StaffInsuranceBeneficiaryUrl, StaffInsurancesUrl, StaffInsurancesNomineeUrl, AdhaarOCRVerificationUrl, PanOCRVerificationUrl, StaffInsurancesBeneficiaryNomineeUrl } from '../url';

// Avoid shipping raw AxiosError to Sentry: err.config carries the auth
// header and request body (Aadhaar/PAN images, staff PII).
const captureScrubbedError = (err, flow) => {
  const scrubbed = new Error(err?.response?.data?.message || err?.message || 'Request failed');
  scrubbed.name = err?.name || 'Error';
  Sentry.captureException(scrubbed, {
    tags: { module: 'beneficiary', flow },
    extra: { status: err?.response?.status },
  });
};

export const getStaffInsuranceAction  = async (company_esi_id) => {
  try {
    const token = await getToken();
    const { data } = await axios.get(`${StaffInsurancesUrl()}?company_esi_id=${company_esi_id}`, getTokenHeader(token));
    return data;
  } catch (err) {
    captureScrubbedError(err, 'getStaffInsuranceAction');
    return { error: true, message: err.response?.data?.message || err.message };
  }
};

export const AddStaffBeneficiaryAction = async (data) => {
  try {
    const token = await getToken();
    const { data: result } = await axios.post(
      `${StaffInsuranceBeneficiaryUrl()}`,
      data,
      getTokenHeader(token),
    );
    return result;
  } catch (err) {
    captureScrubbedError(err, 'AddStaffBeneficiaryAction');
    return { error: true, message: err.response?.data?.message || err.message };
  }
};
export const AddStaffNomineeAction = async (data) => {
  try {
    const token = await getToken();
    const { data: result } = await axios.post(
      `${StaffInsurancesNomineeUrl()}`,
      data,
      getTokenHeader(token),
    );
    return result;
  } catch (err) {
    captureScrubbedError(err, 'AddStaffNomineeAction');
    return { error: true, message: err.response?.data?.message || err.message };
  }
};
export const deleteStaffAction = async (is_beneficiary, is_nominee, staff_no, company_esi_id) => {
  try {
    const token = await getToken();
    const { data } = await axios.delete(
      `${StaffInsurancesUrl()}?staff_id=${staff_no}&is_nominee=${is_nominee}&is_beneficiary=${is_beneficiary}&company_esi_id=${company_esi_id}`,
      getTokenHeader(token)
    );
    return data;
  } catch (err) {
    captureScrubbedError(err, 'deleteStaffAction');
    return { error: true, message: err.response?.data?.message || err.message };
  }
};

export const AdhaarOCRVerficiationAction = async (data, requireAddressMapping = false) => {
  try {
    const token = await getToken();
    const { data: result } = await axios.post(
      `${AdhaarOCRVerificationUrl(requireAddressMapping)}`,
      data,
      { headers: { Authorization: 'Bearer ' + token } },
    );
    return result;
  } catch (err) {
    captureScrubbedError(err, 'AdhaarOCRVerficiationAction');
    return { error: true, message: err?.response?.data?.message || err?.message || 'OCR processing failed' };
  }
};

export const PanOCRVerificationAction = async (data) => {
  try {
    const token = await getToken();
    const { data: result } = await axios.post(
      `${PanOCRVerificationUrl()}`,
      data,
      { headers: { Authorization: 'Bearer ' + token } },
    );
    return result;
  } catch (err) {
    captureScrubbedError(err, 'PanOCRVerificationAction');
    return { error: true, message: err?.response?.data?.message || err?.message || 'OCR processing failed' };
  }
};
export const AddStaffBeneficiaryNomineeAction = async (data) => {
  try {
    const token = await getToken();
    const { data: result } = await axios.post(
      `${StaffInsurancesBeneficiaryNomineeUrl()}`,
      data,
      getTokenHeader(token),
    );
    return result;
  } catch (err) {
    captureScrubbedError(err, 'AddStaffBeneficiaryNomineeAction');
    return { error: true, message: err.response?.data?.message || err.message };
  }
};
